// extracted by mini-css-extract-plugin
export default {"curso":"styles_curso__1HIzC","content_button":"styles_content_button__F7tMI"};